<script setup lang="ts">
import { ListPostsProps } from "./ListPosts.props"
import { customPaths } from "~/utils/constants"

const props = defineProps<ListPostsProps>()

const emit = defineEmits<{ (e: "onShowMore"): void }>()

const { t } = useI18n()
const route = useRoute()

const { isOpen, switchState: openMagazineCategories } = useUIState(
  MAGAZINE_CATEGORIES_MODAL
)

const dropdownArgs = reactive({
  label: t("magazine.categories"),
  openModal: false,
  dropdownMenu: null
})

const { data: getCategoriesOfMagazine, error: errorGetCategoriesOfMagazine } =
  await useFetch(`/api/magazine/getCategories`, {
    method: "GET"
  })

if (errorGetCategoriesOfMagazine.value) {
  console.warn(
    "error get categories of Magazine",
    errorGetCategoriesOfMagazine.value
  )
} else {
  // @ts-ignore
  dropdownArgs.dropdownMenu = [
    {
      label: t("magazine.allPosts"),
      value: customPaths.magazineAllPosts
    },
    ...getCategoriesOfMagazine.value.map(
      (category: { title: string; slug: string }) => ({
        label: category.title,
        value: category.slug
      })
    )
  ]
}

// const handleShowMore = () => {
//   emit("onShowMore")
// }

const openModal = () => {
  dropdownArgs.openModal = true
}

const closeModal = (value: boolean) => {
  dropdownArgs.openModal = value
}

const goToCategoryMagazine = (e: any) => {
  navigateTo(e.value)
  openMagazineCategories(false)
}

const currentPage = computed(() =>
  route.params.page ? parseInt(route.params.page as string) : 1
)

const totalPages = computed(() => Math.ceil(props.totalPosts / 12))
</script>

<template>
  <div class="list-posts-wrapper py-6">
    <div
      class="
        col-span-full
        mb-4
        flex flex-col
        md:mb-6
        md:flex-row
        md:items-center
        md:justify-between
      "
    >
      <div class="flex flex-col md:flex-row md:items-center md:gap-6">
        <h1 v-if="title" class="hyppo-bold md:elephant-bold">
          {{ title }}
        </h1>

        <span class="mouse mb-4 block md:mb-0">
          {{ $t("magazine.totalPublishedPost", { totalPosts: totalPosts }) }}
        </span>
      </div>

      <div
        class="md:border-black-20 order-first md:order-last md:border-b-[1px]"
        v-if="hasDropdownCategory && dropdownArgs"
      >
        <div class="hidden md:block">
          <span class="mouse text-black-80 mr-3 uppercase">{{
            $t("magazine.plp.filterBy")
          }}</span>
          <FiltersUtilsDropdownWithoutAlgolia
            :text="dropdownArgs.label"
            :opened="dropdownArgs.openModal"
            attachTo="right"
            @onOpen="openModal"
            @onClose="() => closeModal(false)"
            class="z-low-ground"
          >
            <div class="space-y-1">
              <AppLink
                v-for="{ label, value } in dropdownArgs.dropdownMenu"
                :key="value"
                :to="value"
                class="
                  mouse
                  hover:mouse-medium
                  flex
                  min-w-[150px]
                  cursor-pointer
                  justify-between
                  p-2
                "
              >
                {{ label }}
              </AppLink>
            </div>
          </FiltersUtilsDropdownWithoutAlgolia>
        </div>
        <div class="negative-margined block md:hidden">
          <FiltersUtilsMobileFiltersBarMagazine
            :sorting-open="isOpen"
            @onSearch="openMagazineCategories(true)"
            class="mb-3"
          />
          <FiltersUtilsModalsMagazineCategories
            :items="dropdownArgs.dropdownMenu"
            @onSelectItem="(e) => goToCategoryMagazine(e)"
            @onClose="() => openMagazineCategories(false)"
          />
        </div>
      </div>
    </div>

    <div class="grid-container col-span-full gap-y-10" v-if="postsList">
      <CardBlogPost
        v-for="(card, index) in postsList"
        :key="index"
        v-bind="card"
        class="col-span-full md:col-span-4"
      />

      <CartUtilsLogin
        :upperText="$t('loginBanner.type2.upperText')"
        show-login-button
        class="negative-margined col-span-full row-start-2 text-center"
      />
    </div>

    <div class="grid-container mt-6 justify-items-center">
      <div
        class="
          col-span-4 col-start-1
          w-min
          md:col-span-6 md:col-start-4
          lg:col-start-4
        "
      >
        <NavigationPaginator
          v-if="totalPages > 1"
          class="mx-auto w-full justify-between"
          :current-page="currentPage"
          :total-pages="totalPages"
        />
      </div>
    </div>
  </div>
</template>
